import React, { useContext, useState } from 'react';
import styled from '@emotion/styled';
import SyncItem from './SyncItem';
import { handleError, request } from 'app/api';
import { toast } from 'react-toastify';
import { LanguageContext } from 'components/language';
import { get } from 'lodash';
import { useSelector } from 'react-redux';
import { userSelector } from 'app/selectors';

const syncActions = [
    {
        icon: 'dollor-icon',
        title: 'SEND_PRICES_ACTION',
        id: 'send-prices',
        description: 'SEND_PRICES_ACTION_DESCRIPTION',
    },
    {
        icon: 'x',
        title: 'SEND_RESTRICTIONS_ACTION',
        id: 'send-restrictions',
        description: 'SEND_RESTRICTIONS_ACTION_DESCRIPTION',
        disabled: true,
    },
    {
        icon: 'clipboard2',
        title: 'SEND_ROOM_AVAILABILITY_ACTION',
        id: 'send-room-availability',
        description: 'SEND_ROOM_AVAILABILITY_ACTION_DESCRIPTION',
    },
    {
        icon: 'calendar',
        title: 'INVENTORY_ORDERS_ACTION',
        id: 'inventory-orders',
        description: 'INVENTORY_ORDERS_ACTION_DESCRIPTION',
    },
    {
        icon: 'calendar',
        title: 'OTELMS_INVENTORY_ACTION',
        id: 'otelms-inventory',
        disabled: true,
        description: 'OTELMS_INVENTORY_ACTION_DESCRIPTION',
    },
    {
        icon: 'refresh',
        title: 'CREATE_ORDERS_FROM_SUMMARY_ACTION',
        id: 'create-orders-from-summary',
        disabled: true,
        description: 'CREATE_ORDERS_FROM_SUMMARY_ACTION_DESCRIPTION',
    },
    {
        icon: 'calendar-money',
        title: 'UPDATE_TAX_ACTION',
        id: 'update-tax',
        description: 'UPDATE_TAX_ACTION_DESCRIPTION',
    },
    {
        icon: 'refresh',
        title: 'UPDATE_RATE_DISCOUNT_ACTION',
        id: 'update-rate-discount',
        description: 'UPDATE_RATE_DISCOUNT_ACTION_DESCRIPTION',
    },
];

const Synchronization = () => {
    const [loading, setLoading] = useState(null);
    const { t } = useContext(LanguageContext);
    const user = useSelector(userSelector);
    const activeHotelId = get(user, 'activeHotelId');

    const handleSyncAction = (action) => {
        setLoading(action.id);
        switch (action.id) {
            case 'send-prices':
                request({
                    url: `/booking-com/update-rate-room-price?hotelId=${activeHotelId}`,
                    method: 'put',
                    success: () => {
                        setTimeout(() => {
                            toast.success(t('PRICES_SENT_SUCCESSFULLY'));
                        }, 1000);
                    },
                    fail: handleError,
                    finish: () => {
                        setTimeout(() => {
                            setLoading(null);
                        }, 1000);
                    },
                });
                break;
            case 'send-room-availability':
                request({
                    url: `/booking-com/update-rate-room-availability?hotelId=${activeHotelId}`,
                    method: 'put',
                    success: () => {
                        setTimeout(() => {
                            toast.success(t('ROOM_AVAILABILITY_SENT_SUCCESSFULLY'));
                        }, 1000);
                    },
                    fail: handleError,
                    finish: () => {
                        setTimeout(() => {
                            setLoading(null);
                        }, 1000);
                    },
                });
                break;
            case 'inventory-orders':
                request({
                    url: `/booking-com/update-orders?hotelId=${activeHotelId}`,
                    method: 'put',
                    success: () => {
                        setTimeout(() => {
                            toast.success(t('ORDERS_SENT_SUCCESSFULLY'));
                        }, 1000);
                    },
                    fail: handleError,
                    finish: () => {
                        setTimeout(() => {
                            setLoading(null);
                        }, 1000);
                    },
                });
                break;
            case 'update-tax':
                request({
                    url: `/booking-com/update-tax?hotelId=${activeHotelId}`,
                    method: 'put',
                    success: () => {
                        setTimeout(() => {
                            toast.success(t('TAX_SENT_SUCCESSFULLY'));
                        }, 1000);
                    },
                    fail: handleError,
                    finish: () => {
                        setTimeout(() => {
                            setLoading(null);
                        }, 1000);
                    },
                });
                break;
            case 'update-rate-discount':
                request({
                    url: `/booking-com/update-rate-discount?hotelId=${activeHotelId}`,
                    method: 'put',
                    success: () => {
                        setTimeout(() => {
                            toast.success(t('RATE_DISCOUNT_SENT_SUCCESSFULLY'));
                        }, 1000);
                    },
                    fail: handleError,
                    finish: () => {
                        setTimeout(() => {
                            setLoading(null);
                        }, 1000);
                    },
                });
                break;
            default:
                break;
        }
    };

    return (
        <Styled>
            {syncActions
                .filter((action) => !action.disabled)
                .map((action) => (
                    <SyncItem key={action.id} {...action} loading={loading} onClick={() => handleSyncAction(action)} />
                ))}
        </Styled>
    );
};

const Styled = styled.div`
    display: flex;
    padding: 12px;
    flex-direction: column;
`;

export default Synchronization;
